import MobilePhotoHeader from '../src/MobilePhotoHeader.tsx';
export default MobilePhotoHeader;
